import { useSelector } from "react-redux";
import Avatar from "jadro-pico-app/Components/UI/Avatar/Avatar";
import FontText from "jadro-pico-app/Components/UI/FontText/FontText";
import { FontSizeEnum, FontTypeEnum } from "jadro-pico-app/Components/UI/FontText/FontTextEnums";
import { ThemeColorEnum } from "jadro-pico-app/Components/UI/Themes/ThemeEnums";
import AutoLayout from "jadro-pico-app/Components/UI/Layouts/AutoLayout/AutoLayout";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "jadro-pico-app/Components/UI/Layouts/AutoLayout/AutoLayoutEnums";
import Skeleton from "jadro-pico-app/Components/UI/Skeleton/Skeleton";
import { SkeletonShapeEnum } from "jadro-pico-app/Components/UI/Skeleton/SkeletonEnums";
import { AppAuthStatusEnum, type AppAuthState } from "jadro-pico-app/Redux/AppAuthReducer";

function ProfileIdentity() {
  const { user, status } = useSelector((s: { auth: AppAuthState }) => s.auth);
  if (status === AppAuthStatusEnum.UNAUTHENTICATED) return null;

  const displayName = user ? user.name || user.preferred_username || user.email || "" : "";

  return (
    <AutoLayout
      $direction={AutoLayoutDirectionEnum.VERTICAL}
      $align={AutoLayoutAlignEnum.CENTER}
      $horizontalResizing={AutoLayoutResizingEnum.FILL}
      $gap={12}
      $topBottomPadding={8}
    >
      {user ? (
        <>
          <Avatar name={displayName} size={96} />
          <FontText
            text={displayName}
            $fontType={FontTypeEnum.TITLE}
            $fontSize={FontSizeEnum.LARGE}
            $color={ThemeColorEnum.ON_SURFACE}
          />
        </>
      ) : (
        <>
          <Skeleton shape={SkeletonShapeEnum.CIRCLE} width={96} />
          <Skeleton shape={SkeletonShapeEnum.TEXT} width={160} height={28} />
        </>
      )}
    </AutoLayout>
  );
}

export default ProfileIdentity;
